import { ComponentProps } from "react";
import { Logo } from "../../../Icons";

export const NavbarLogo = ({ ...rest }: ComponentProps<"svg">) => {
  return <Logo {...rest} />;
};
